<template>
  <div class="liabilities">
    <b-card no-body class="custom-card">
      <b-card-header class="py-2 px-3 custom-card-header">
        <b-row align-v="center">
          <b-col cols="6">
            <h3 class="mb-0">BANKING PAYMENT RECORDS (SOURCE: CCRIS, BANK NEGARA MALAYSIA)</h3>
          </b-col>
          <b-col cols="6" class="text-right">
            <b-link href="javascript:void(0)" @click="modals.show_liabilities_full_view = true" class="full-view-link">
              <b-icon icon="eye-fill" variant="primary"></b-icon>
              Full View
            </b-link>
          </b-col>
        </b-row>  
      </b-card-header>

      <b-card-body class="p-0">
        <!-- Liabilities Table -->
        <div class="table-container">
          <table class="liabilities-table bordered summary-table">
            <thead>
              <tr>
                <th style="width: 40%">Summary of Potential & Current Liabilities</th>
                <th style="width: 20%">Outstanding</th>
                <th style="width: 20%">Total Limit</th>
                <th style="width: 20%">FEC Limit</th>
              </tr>
            </thead>
            <tbody>
              <!-- As Borrower Row -->
              <tr>
                <td><strong>As Borrower</strong></td>
                <td style="text-align: center">{{ liabilitiesData.as_borrower.outstanding }}</td>
                <td style="text-align: center">{{ liabilitiesData.as_borrower.total_limit }}</td>
                <td style="text-align: center">{{ liabilitiesData.as_borrower.fec_limit }}</td>
              </tr>
              <!-- As Guarantor Row -->
              <tr>
                <td><strong>As Guarantor</strong></td>
                <td style="text-align: center">{{ liabilitiesData.as_guarantor.outstanding }}</td>
                <td style="text-align: center">{{ liabilitiesData.as_guarantor.total_limit }}</td>
                <td style="text-align: center">{{ liabilitiesData.as_guarantor.fec_limit }}</td>
              </tr>
              <!-- Total Row -->
              <tr class="total-row">
                <td><strong>Total</strong></td>
                <td style="text-align: center"><strong>{{ liabilitiesData.total.outstanding }}</strong></td>
                <td style="text-align: center"><strong>{{ liabilitiesData.total.total_limit }}</strong></td>
                <td style="text-align: center"><strong>{{ liabilitiesData.total.fec_limit }}</strong></td>
              </tr>
              <!-- Legal Action Taken Row -->
              <tr>
                <td><strong>Legal Action Taken</strong></td>
                <td colspan="3" style="text-align: center">{{ legalActionTaken }}</td>
              </tr>
              <!-- Special Attention Account Row -->
              <tr>
                <td><strong>Special Attention Account</strong></td>
                <td colspan="3" style="text-align: center">{{ specialAttentionAccount }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-card-body>

      <!-- Full View Modal -->
      <LiabilitiesModal
        :liabilities="ccrisBankingRecords"
        :show_liabilities_full_view.sync="modals.show_liabilities_full_view"
      />
    </b-card>
  </div>
</template>

<script>
import LiabilitiesModal from '@/views/CustomerProfile/CustomerModals/LiabilitiesModal.vue'

export default {
  name: 'Liabilities',
  props: {
    ccrisBankingRecords: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    LiabilitiesModal,
  },
  data() {
    return {
      modals: {
        show_liabilities_full_view: false
      }
    }
  },
  computed: {
    liabilitiesData() {
      return this.ccrisBankingRecords.liabilities || {
        as_borrower: { outstanding: '-', total_limit: '-', fec_limit: '-' },
        as_guarantor: { outstanding: '-', total_limit: '-', fec_limit: '-' },
        total: { outstanding: '-', total_limit: '-', fec_limit: '-' }
      };
    },
    legalActionTaken() {
      return this.ccrisBankingRecords.legal_action_taken || 'N';
    },
    specialAttentionAccount() {
      return this.ccrisBankingRecords.special_attention_account || 'N';
    }
  },
};
</script>

<style scoped>
.liabilities {
  font-family: inherit;
}

.custom-card {
  border: 1px solid #dee2e6;
  border-radius: 4px;
}

.custom-card-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
}

.full-view-link {
  color: #007bff;
  text-decoration: none;
  font-weight: 500;
}

.full-view-link:hover {
  text-decoration: underline;
}

.table-container {
  width: 100%;
  overflow-x: auto;
}

/* Styles matching directories business tables */
.liabilities-table {
  border-collapse: collapse;
  width: 100%;
  font-family: inherit;
  font-size: 0.875rem;
  margin-bottom: 0;
}

.liabilities-table.bordered,
.liabilities-table th,
.liabilities-table td {
  border: 1px solid #000 !important;
}

/* Summary table specific header styling */
.summary-table th {
  background-color: #252938 !important;
  color: #fff !important;
  border: none !important;
  vertical-align: top !important;
  text-transform: none !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  line-height: 19.5px !important;
  padding: 9px 12px !important;
  text-align: center;
}

.liabilities-table td {
  background-color: #fff !important;
  color: #000 !important;
  padding: 8px 6px;
  text-align: left;
  vertical-align: middle;
}

.liabilities-table tbody tr:nth-child(even) {
  background-color: #f8f9fa;
}

.liabilities-table tbody tr:nth-child(odd) {
  background-color: #ffffff;
}

.total-row {
  background-color: #e9ecef !important;
}

.total-row td {
  font-weight: 600;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .table-container {
    font-size: 0.7rem;
  }
  
  .liabilities-table th,
  .liabilities-table td {
    padding: 6px 4px;
  }
}
</style>